import { SVGProps } from 'react'

export const ChevronUp = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9464 17L12 9.05356L4.05356 17L3 15.9464L12 6.94644L21 15.9464L19.9464 17Z"
      fill="currentColor"
    />
  </svg>
)
